// Third-party Library
import { Upload } from "antd";

//components
import { ButtonLink } from "../../../../../../components";

// Constants
import { ROOT_CONSTANT } from "../../../../../../constants";

// Handler
import { templateHDLR } from "../../../../../../handlers";

// Styles
import classes from "../../index.module.css";

const { Dragger } = Upload;
const { icon_excel } = ROOT_CONSTANT.IMG.ICON;

const BulkDownload = () => {
  return (
    <Dragger openFileDialogOnClick={false}>
      <img src={icon_excel} alt="excel icon" style={{ width: "2.5em"}}/>
      <p className={classes["tagline-upload"]}>
        <span className={classes["text-container"]}>
          Click to
          <ButtonLink onClick={() => templateHDLR.getOrderTemplateXLSXFromS3()} style={{ margin:"0 4px"}}>
            download
          </ButtonLink>
          the template
        </span>
      </p>
      <p style={{ color: "gray" }}>employee.bulkupload.xls</p>
    </Dragger>
  );
};

export default BulkDownload;
